import { useEffect, useState } from "react";
import { AxiosPublico } from "../../../../componentes/axios/Axios";
import Linea from "../../../../componentes/graficos/Lineal";
import { HistorialesTemperaturaListar } from "../../../../configuracion/apiUrls";
import RangoInfo from "./RangoInfo";
import ResumenMinMax from "./ResumenMinMax";
import { formatearDatos } from "../../../../componentes/graficos/ValidacionesGraficos";

const rangosOptimos = {
    temperatura: {
        optimo: "18°C - 25°C",
        minimo: "10°C",
        minimoInfo: "Por debajo, el crecimiento se ralentiza",
        maximo: "30°C",
        maximoInfo: "Por encima, puede haber estrés térmico"
    }
};

const HistorialTemperatura = () => {
    const [cargando, setCargando] = useState(true);
    const [dataGrafico, setDataGrafico] = useState(null);
    const [filtro, setFiltro] = useState("dia");
    const [fechaSeleccionada, setFechaSeleccionada] = useState(new Date().toLocaleDateString('en-CA'));
    const [horaSeleccionada, setHoraSeleccionada] = useState(new Date().toTimeString().split(' ')[0].slice(0, 5));
    const [semanaSeleccionada, setSemanaSeleccionada] = useState("");
    const [mesSeleccionado, setMesSeleccionado] = useState(new Date().toISOString().slice(0, 7));
    const [anioSeleccionado, setAnioSeleccionado] = useState(new Date().getFullYear());
    const [resumenData, setResumenData] = useState(null);

    const obtenerFechasDeFiltro = () => {
        let fechaInicio, fechaFin;
        const [year, month, day] = fechaSeleccionada.split('-').map(Number);

        switch (filtro) {
            case "dia":
                fechaInicio = new Date(year, month - 1, day);
                fechaFin = new Date(year, month - 1, day + 1);
                break;
            case "dia-hora":
                const [hour, minute] = horaSeleccionada.split(':').map(Number);
                fechaInicio = new Date(year, month - 1, day, hour, minute);
                fechaFin = new Date(fechaInicio.getTime() + 60 * 60 * 1000);
                break;
            case "semana":
                const [yearWeek, week] = semanaSeleccionada.split('-W').map(Number);
                fechaInicio = getFechaInicioSemanaISO(yearWeek, week);
                fechaFin = new Date(fechaInicio);
                fechaFin.setDate(fechaFin.getDate() + 6); // domingo

                /*const [yearWeek, week] = semanaSeleccionada.split('-W').map(Number);
                const primerDiaDelAnio = new Date(yearWeek, 0, 1);
                const diaDeLaSemanaPrimerDia = primerDiaDelAnio.getDay();
                const ajusteAlLunes = diaDeLaSemanaPrimerDia === 0 ? 1 : 8 - diaDeLaSemanaPrimerDia;
                fechaInicio = new Date(primerDiaDelAnio.getFullYear(), 0, 1 + ajusteAlLunes + (week) * 7);
                fechaFin = new Date(fechaInicio);
                fechaFin.setDate(fechaFin.getDate() + 7);*/
                break;
            case "mes":
                const [mesAnio, mes] = mesSeleccionado.split('-').map(Number);
                fechaInicio = new Date(mesAnio, mes - 1, 1);
                fechaFin = new Date(mesAnio, mes, 1);
                break;
            case "año":
                const anio = parseInt(anioSeleccionado);
                fechaInicio = new Date(anio, 0, 1);
                fechaFin = new Date(anio + 1, 0, 1);
                break;
            default:
                fechaInicio = new Date();
                fechaFin = new Date();
                break;
        }
        return { fechaInicio, fechaFin };
    };

    function getFechaInicioSemanaISO(year, week) {
        const simple = new Date(year, 0, 1 + (week - 1) * 7);
        const dow = simple.getDay(); // 0 = domingo, 1 = lunes, ...
        const ISOday = dow === 0 ? 7 : dow; // convertir domingo a 7
        const fechaInicio = new Date(simple);
        fechaInicio.setDate(simple.getDate() - ISOday + 1); // ajustar al lunes
        return fechaInicio;
    }


    const fetchDatos = async () => {
        setCargando(true);
        try {
            const invernaderoId = localStorage.getItem("invernaderoId");
            const response = await AxiosPublico.get(HistorialesTemperaturaListar, { params: obtenerFechasDeFiltro() });

            if (response.data && Array.isArray(response.data.historiales)) {
                const gruposPorSensor = {};
                response.data.historiales.forEach(item => {
                    const sensorInvernaderoId = item['SensorTemperatura.invernaderoId'];
                    const sensorKey = item['SensorTemperatura.id'] ?? "desconocido";

                    if (sensorInvernaderoId && sensorInvernaderoId != invernaderoId) return;

                    if (!gruposPorSensor[sensorKey]) {
                        gruposPorSensor[sensorKey] = [];
                    }
                    gruposPorSensor[sensorKey].push(item);
                });

                const resumenesPorSensor = Object.entries(gruposPorSensor).map(([sensorId, datos]) => {
                    const valores = datos.map(item => item.valor);

                    const minimo = valores.length > 0 ? Math.min(...valores) : null;
                    const maximo = valores.length > 0 ? Math.max(...valores) : null;
                    const promedio = valores.length > 0 ? valores.reduce((sum, val) => sum + val, 0) / valores.length : null;

                    const puntoMinimo = datos.find(item => item.valor === minimo);
                    const puntoMaximo = datos.find(item => item.valor === maximo);

                    return {
                        sensorId: sensorId,
                        promedio: promedio,
                        minimo: {
                            valor: minimo,
                            fechaHora: puntoMinimo?.fecha,
                        },
                        maximo: {
                            valor: maximo,
                            fechaHora: puntoMaximo?.fecha,
                        }
                    };
                });

                const datasets = Object.entries(gruposPorSensor).map(([sensorId, datos]) =>
                    formatearDatos(datos, `Temperatura ${sensorId}`, 'temperatura', obtenerFechasDeFiltro(), filtro)
                );

                setDataGrafico(datasets);
                setResumenData(resumenesPorSensor);
            }
        } catch (error) {
            console.error("Error al obtener los datos para gráficas:", error);
        } finally {
            setCargando(false);
        }
    };


    const handleApplyFilter = () => {
        fetchDatos();
    };

    useEffect(() => {
        fetchDatos();
    }, []);

    return (
        <div className="col-12 mb-4">
            {cargando ? (
                <div className="d-flex justify-content-center align-items-center flex-column py-5">
                    <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }} role="status"></div>
                </div>
            ) : (
                <>
                    <h5 className="text-center">Temperatura</h5>
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3 gap-2 px-2">
                        <label htmlFor="filtro" className="form-label mb-0 fw-semibold text-nowrap">
                            Filtro:
                        </label>
                        <div className="d-grid d-md-flex flex-wrap gap-2 w-100">
                            <div className="d-grid d-md-flex gap-2 mb-2 mb-md-0">
                                <button
                                    className={`btn btn-sm mx-1 ${filtro === "dia" ? "btn-primary" : "btn-outline-primary"}`}
                                    onClick={() => setFiltro("dia")}>Día</button>
                                <button
                                    className={`btn btn-sm mx-1 ${filtro === "dia-hora" ? "btn-primary" : "btn-outline-primary"}`}
                                    onClick={() => setFiltro("dia-hora")}>Hora</button>
                                <button
                                    className={`btn btn-sm mx-1 ${filtro === "semana" ? "btn-primary" : "btn-outline-primary"}`}
                                    onClick={() => setFiltro("semana")}>Semana</button>
                                    <button
                                    className={`btn btn-sm mx-1 ${filtro === "mes" ? "btn-primary" : "btn-outline-primary"}`}
                                    onClick={() => setFiltro("mes")}>Mes</button>
                                <button
                                    className={`btn btn-sm mx-1 ${filtro === "año" ? "btn-primary" : "btn-outline-primary"}`}
                                    onClick={() => setFiltro("año")}>Año</button>
                            </div>
                        </div>
                    </div>
                    {(filtro === "dia" || filtro === "dia-hora") && (
                        <div className="row mb-3 gx-2 px-2 align-items-center">
                            <div className="col-12 col-md-auto">
                                <label htmlFor="fechaSelect" className="form-label mb-0 fw-semibold">Fecha:</label>
                            </div>
                            <div className="col-12 col-sm">
                                <input
                                    type="date"
                                    id="fechaSelect"
                                    className="form-control form-control-sm"
                                    style={{ width: "70%" }}
                                    value={fechaSeleccionada}
                                    onChange={(e) => setFechaSeleccionada(e.target.value)}
                                />
                            </div>
                            {filtro === "dia-hora" && (
                                <>
                                    <div className="col-12 col-md-auto mt-2 mt-md-0">
                                        <label htmlFor="horaSelect" className="form-label mb-0 fw-semibold">Hora:</label>
                                    </div>
                                    <div className="col-12 col-sm">
                                        <input
                                            type="time"
                                            id="horaSelect"
                                            className="form-control form-control-sm"
                                            style={{ width: "50%" }}
                                            value={horaSeleccionada}
                                            onChange={(e) => setHoraSeleccionada(e.target.value)}
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                    )}
                    {filtro === "semana" && (
                        <div className="row mb-3 gx-2 px-2 align-items-center">
                            <div className="col-12 col-md-auto">
                                <label htmlFor="semanaSelect" className="form-label mb-0 fw-semibold">Semana:</label>
                            </div>
                            <div className="col-12 col-sm">
                                <input
                                    type="week"
                                    id="semanaSelect"
                                    className="form-control form-control-sm"
                                    style={{ width: "60%" }}
                                    value={semanaSeleccionada}
                                    onChange={(e) => setSemanaSeleccionada(e.target.value)}
                                />
                            </div>
                        </div>
                    )}
                    {filtro === "mes" && (
                        <div className="row mb-3 gx-2 px-2 align-items-center">
                            <div className="col-12 col-md-auto">
                                <label htmlFor="mesSelect" className="form-label mb-0 fw-semibold">Mes:</label>
                            </div>
                            <div className="col-12 col-sm">
                                <input
                                    type="month"
                                    id="mesSelect"
                                    className="form-control form-control-sm"
                                    style={{ width: "60%" }}
                                    value={mesSeleccionado}
                                    onChange={(e) => setMesSeleccionado(e.target.value)}
                                />
                            </div>
                        </div>
                    )}
                    {filtro === "año" && (
                        <div className="row mb-3 gx-2 px-2 align-items-center">
                            <div className="col-12 col-md-auto">
                                <label htmlFor="anioSelect" className="form-label mb-0 fw-semibold">Año:</label>
                            </div>
                            <div className="col-12 col-sm">
                                <input
                                    type="number"
                                    id="anioSelect"
                                    className="form-control form-control-sm"
                                    style={{ width: "50%" }}
                                    min="2000"
                                    max={new Date().getFullYear()}
                                    value={anioSeleccionado}
                                    onChange={(e) => setAnioSeleccionado(e.target.value)}
                                />
                            </div>
                        </div>
                    )}
                    <div className="d-grid mb-3 px-2">
                        <button
                            className="btn btn-primary btn-sm"
                            onClick={handleApplyFilter}>
                            Aplicar Filtros
                        </button>
                    </div>
                    <div className="row">
                        <div className="col-12 col-md-3 mb-3">
                            <RangoInfo tipo="Valores optimos temperatura" rango={rangosOptimos.temperatura} />
                        </div>
                        {dataGrafico && dataGrafico.length > 0 ? (
                            <div className="col-12 col-md-9 mb-4">
                                {dataGrafico.map((grafico, idx) => (
                                    <div key={idx}>
                                        <h5 className="text-center">{grafico.titulo}</h5>
                                        <Linea datos={grafico} />
                                        <ResumenMinMax datos={resumenData[idx]} filtro={filtro} />
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <p className="text-center py-5">No hay datos para mostrar con los filtros seleccionados.</p>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};
export default HistorialTemperatura;